export const PATHS = {
  HOME_PAGE: "/",
  OVERVIEW_BITEL: "/overview/bitel",
  OVERVIEW_MYTEL: "/overview/mytel",
  OVERVIEW_HALOTEL: "/overview/halotel",
  BITEL: "/bitel",
  HALOTEL: "/halotel",
  MYTEL: "/mytel",

  BITEL_AIRTIME: "/bitel-airtime",
  BITEL_SUBASTA: "/bitel-subasta",

  HALOTEL_HALOGAME: "/halotel-halogame",
  HALOTEL_AIRTIME: "/halotel-airtime",

  MYTEL_VOICEMESSAGE: "/mytel-voicemessage",
  MYTEL_AUCTION: "/mytel-auction",
  VM_MYTEL: "/mytel-vmail",
  MYTEL_ERROR_CODE: "/error-code-auction-mytel",

  VMAIL_UNITEL: "/unitel-vmail",
  UNITEL_REVENUE: "/game-unitel",
  UNITEL_REVENUE_UNITEL_GROUP: "/game-unitel-unitel-group",

  LOGIN: "/login",

  VMAIL_NTM_AIRTIME: "/natcom-vmail",
  NATCOM_VMAIL_CURRENT_MESSAGE: "/natcom-vmail-current-message",
  NATCOM_VMAIL_MISS_CALL: "/natcom-vmail-miss-call",
  NATCOM_NTM: "/natcom-ntm",
  NATCOM_AIRTIME: "/natcom-airtime",

  CONFIG_ALERT: "/config-alert",

  MAGIC_WHEEL: "/magic-wheel",

  MOVITEL_MAGIC_WHEEL: "/movitel-letra-magica",

  BICAGAME: "/bicagame",
  BICAGAME_VINA: "/bicagame-vina",

};
